module.exports = __webpack_public_path__ + "img/frame (164).b804b915.jpg";